"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactVis = require("react-vis");

var _propTypes2 = require("../../constants/propTypes");

var _styles = require("../../styles");

var _ResizableXYPlot = _interopRequireDefault(require("../ResizableXYPlot"));

var _RecentPerformanceCrosshair = require("../RecentPerformanceCrosshair");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BatteryPercentageChartLinkedInteraction = function BatteryPercentageChartLinkedInteraction(_ref) {
  var coordinatesGroupedByTime = _ref.coordinatesGroupedByTime,
      crosshairCoordinateValues = _ref.crosshairCoordinateValues,
      endMillis = _ref.endMillis,
      individualBatteryCoordinates = _ref.individualBatteryCoordinates,
      individualBatteryKeys = _ref.individualBatteryKeys,
      isToggleActive = _ref.isToggleActive,
      setCrosshairCoordinateValues = _ref.setCrosshairCoordinateValues,
      setFocusedBattery = _ref.setFocusedBattery,
      startMillis = _ref.startMillis;
  return /*#__PURE__*/_react["default"].createElement(_ResizableXYPlot["default"], {
    animation: "noWobble",
    dataTestid: "battery-percentage-chart",
    height: 100,
    margin: {
      left: 70,
      right: 0
    },
    onMouseLeave: function onMouseLeave() {
      return setCrosshairCoordinateValues(null);
    },
    xDomain: [startMillis, endMillis],
    xType: "time",
    yDomain: [0, 100]
  }, /*#__PURE__*/_react["default"].createElement(_reactVis.LineSeries, {
    data: Object.values(coordinatesGroupedByTime),
    style: _styles.invisibleLineStyle,
    onNearestX: setCrosshairCoordinateValues
  }), /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.RecentPerformanceCrosshair, {
    coordinate: crosshairCoordinateValues
  }), !isToggleActive && individualBatteryKeys.map(function (key) {
    return /*#__PURE__*/_react["default"].createElement(_reactVis.LineSeries, {
      curve: "curveLinear",
      data: individualBatteryCoordinates[key],
      key: key,
      onSeriesClick: function onSeriesClick() {
        return setFocusedBattery(key);
      },
      style: _objectSpread(_objectSpread({}, _styles.invisibleLineStyle), {}, {
        strokeWidth: 4
      })
    });
  }));
};

BatteryPercentageChartLinkedInteraction.propTypes = {
  coordinatesGroupedByTime: _propTypes2.groupedCoordinatePropTypes,
  crosshairCoordinateValues: _propTypes["default"].shape({
    x: _propTypes["default"].number
  }),
  endMillis: _propTypes["default"].number.isRequired,
  individualBatteryCoordinates: _propTypes["default"].shape({
    'Battery 1': _propTypes2.coordinatePropTypes
  }),
  individualBatteryKeys: _propTypes["default"].arrayOf(_propTypes["default"].string),
  isToggleActive: _propTypes["default"].bool.isRequired,
  setCrosshairCoordinateValues: _propTypes["default"].func.isRequired,
  setFocusedBattery: _propTypes["default"].func.isRequired,
  startMillis: _propTypes["default"].number.isRequired
};
BatteryPercentageChartLinkedInteraction.defaultProps = {
  coordinatesGroupedByTime: {},
  crosshairCoordinateValues: {},
  individualBatteryCoordinates: {},
  individualBatteryKeys: []
};
var _default = BatteryPercentageChartLinkedInteraction;
exports["default"] = _default;